module.exports = __webpack_public_path__ + "img/menu-data.d0391631.png";